import { takeLatest, all, call, put } from 'redux-saga/effects';
import {
    startDeleteBranch,
    startUsersByBranchId,
    setBranchUsers,
    setBranches,
    startAllBranch,
    completedAction,
    startAddingNewBranch,
    branchDetails,
    startBranchDetailsOnID,
    startAddingBranchUser,
    startDynamicFilter,
    setBranchUserData,
    startBranchUserData,
    startUpdatingBranchUser,
    startBranchAddressList,
    setBranchAddressList,
    startAddOrEditAddress
} from './branch';
import { setFormNavigate } from '../formNavigate/formNavigateSlice';
import {
    addNewBranch,
    getBranchDetails,
    dynamicFilterBranch,
    deleteBranch,
    getBranchByPagination,
    getAllBranches,
    branchAddressList,
    addBranchAddress,
    updateBranchAddress
} from 'utils/apis/branch';
import { addBranchUser, branchUsers, getBranchUsersByPaginationAndBranchId, updateBranchUserDetail } from 'utils/apis/branch-user';
import { openSnackbar } from '../snackbar';

function* addingResponseHandler({ payload }) {
    try {
        yield call(addNewBranch, payload);
        yield put(startAllBranch());
        yield put(setFormNavigate(true));
        yield put(completedAction());
        yield put(
            openSnackbar({
                open: true,
                message: payload?.url === 'edit' ? 'Branch Updated Successfully' : 'Branch Added Successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                },
                close: false,
                actionButton: false
            })
        );
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

function* startAddingNewBranchFetchWatcher() {
    yield takeLatest(startAddingNewBranch.type, addingResponseHandler);
}

function* branchDetailsResponseHandler({ payload }) {
    try {
        const response = yield call(getBranchDetails, payload);
        yield put(branchDetails(response));
        yield put(completedAction());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

function* startBranchDetailsByIDFetchWatcher() {
    yield takeLatest(startBranchDetailsOnID.type, branchDetailsResponseHandler);
}

function* branchesResponseHandler({ payload }) {
    try {
        let response;
        if (payload?.noPagination) {
            response = yield call(getAllBranches);
        } else {
            response = yield call(getBranchByPagination);
        }

        yield put(setBranches(response));
        yield put(completedAction());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

function* startBranchesFetchWatcher() {
    yield takeLatest(startAllBranch.type, branchesResponseHandler);
}

function* deleteBranchesResponseHandler({ payload }) {
    const { filterData, filterStatus, page, rowsPerPage, id } = payload;
    try {
        yield call(deleteBranch, id);
        if (filterStatus) {
            yield put(startDynamicFilter({ ...filterData, page, rowsPerPage }));
        } else {
            yield put(startAllBranch());
        }
        yield put(completedAction());
        yield put(
            openSnackbar({
                open: true,
                message: 'Branch Deleted Successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                },
                close: false,
                actionButton: false
            })
        );
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

function* startDeleteBranchWatcher() {
    yield takeLatest(startDeleteBranch.type, deleteBranchesResponseHandler);
}

function* dynamicFilterResponseHandler({ payload }) {
    try {
        const response = yield call(dynamicFilterBranch, payload);
        yield put(setBranches(response));
        yield put(completedAction());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

function* startDynamicFilterWatcher() {
    yield takeLatest(startDynamicFilter.type, dynamicFilterResponseHandler);
}

function* branchAddressListResponseHandler({ payload }) {
    try {
        const response = yield call(branchAddressList, payload.branchId);
        yield put(setBranchAddressList(response));
        yield put(completedAction());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

function* startBranchAddressListWatcher() {
    yield takeLatest(startBranchAddressList.type, branchAddressListResponseHandler);
}

function* addOrEditAddressResponseHandler({ payload }) {
    try {
        if (payload?.type === 'ADD') {
            yield call(addBranchAddress, payload.data);
        } else {
            yield call(updateBranchAddress, payload.data);
        }
        yield put(startBranchAddressList({ branchId: payload.branchId }));
        yield put(completedAction());
        yield put(
            openSnackbar({
                open: true,
                message: payload?.type === 'ADD' ? 'Address Added Successfully' : 'Address Updated Successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                },
                close: false,
                actionButton: false
            })
        );
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

function* startAddOrEditAddressWatcher() {
    yield takeLatest(startAddOrEditAddress.type, addOrEditAddressResponseHandler);
}

export default function* branchDataSaga() {
    yield all([
        call(startAddingNewBranchFetchWatcher),
        call(startBranchDetailsByIDFetchWatcher),
        call(startBranchesFetchWatcher),
        call(startDeleteBranchWatcher),
        call(startDynamicFilterWatcher),
        call(startBranchAddressListWatcher),
        call(startAddOrEditAddressWatcher)
    ]);
}
